export default __webpack_public_path__ + "static/media/logo.c42dac8e.png";